function sentDataBackendDoubleOptin(data, from_form, form, buttonForm) {
  jQuery.ajax({
    type: "POST",
    url: local_object.ajax_url,
    data: {
      data: data,
      from_form: from_form,
      action: "submits_backend_double_optin"
    },
    success: function(response) {
      let res = JSON.parse(response);

      if(res.error === 1){
        setTimeout(function() {
          buttonForm.attr('disabled', false);
          form.removeClass("disabled");
          buttonForm.removeClass("button--loading");
          form.addClass("msj-error");
        }, 2000);

        jQuery('#email_footer').on('change', function(){
          if(form.hasClass("msj-error")){
            form.removeClass("msj-error");
          }
        });

        form.removeClass("msj-error");
      } else {
        setTimeout(function(){
          jQuery("#hide-form-subscribe").trigger("click");
        },6000);

        setTimeout(function() {
          form[0].reset();
          buttonForm.attr('disabled', false);
          form.removeClass("disabled");
          buttonForm.removeClass("button--loading");
          form.removeClass("msj-error");
          form.addClass("success");
        }, 2000);
      }

      setTimeout(function() {
        jQuery(".form-message").removeClass('active');
        form.removeClass("success");
      }, 6000);
    }
  });
}

export default sentDataBackendDoubleOptin;